import { isBrowser, isMobile } from 'react-device-detect';
import styles from './ShopContents.module.css';
import { useRef } from 'react';


const ShopContents = ({shopItems, selectedOption, setSelectedOption, account, setIsHotModalShown, setAuthModalPage, setModalProps, setInfoModalPage}) => {
    const mobileContainerRef = useRef(null);

    const whenTopButtonClicked = () => {
		if (mobileContainerRef.current) {
			mobileContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
		  }
	};

    const whenItemClicked = (item) => {
        if(!account.hotpleId){
            setAuthModalPage(1);
            return;
        }

        setModalProps({item:item});
        setInfoModalPage(71);
	};

    const toggleShopBrandOption = (brand) => {
		if(selectedOption.shop_brand == 'popular' && brand == 'popular')
			return;
		
		if(selectedOption.shop_brand == brand)
			setSelectedOption((prev)=>({...prev, shop_brand:'popular'}));
		else
			setSelectedOption((prev)=>({...prev, shop_brand:brand}));
	}

    function getDiscountRate(item){
        return item.goods_type_dtl_nm=='핫플' ? item.discount_rate : Math.min(account.level,5);
    }

  	return (
        <div className={isBrowser ? styles.contents : undefined} ref={mobileContainerRef}>
            <div className={isBrowser ? styles.filterFrameBrowser2 : styles.filterFrame2}>
                <div className={isBrowser ? styles.tagButtonFrameBrowser : styles.tagButtonFrame2}>
                    <div className={selectedOption.shop_brand == 'popular' ? styles.buttonActive : styles.button} key='popular' onClick={()=>toggleShopBrandOption('popular')}>인기</div>
                    {[...new Set(shopItems.filter(item => selectedOption.shop_category!='top20' ? item.goods_type_dtl_nm==selectedOption.shop_category : true)
                    .sort((a, b) =>
                        selectedOption.shop_category === 'top20'
                        ? b.sale_count - a.sale_count
                        : 0
                    )
                    .slice(0, selectedOption.shop_category === 'top20' ? 20 : shopItems.length).map(item => item.brand_name))].map((brand, index) => (
                        <div className={selectedOption.shop_brand == brand ? styles.buttonActive : styles.button} key={brand} onClick={()=>toggleShopBrandOption(brand)}>#{brand}</div>
                    ))}
                </div>
            </div>
            <div className={isBrowser ? styles.contents1 : undefined}>
                <div className={styles.itemsframe}>
                    {shopItems.filter(item => selectedOption.shop_category!='top20' ? item.goods_type_dtl_nm==selectedOption.shop_category : true).filter(item => selectedOption.shop_brand!='popular' ? item.brand_name==selectedOption.shop_brand : true)
                    .sort((a, b) =>
                        selectedOption.shop_category === 'top20'
                        ? b.sale_count - a.sale_count
                        : 0
                    )
                    .slice(0, selectedOption.shop_brand === 'popular' ? 20 : shopItems.length)
                    .map(item => (
                        <div className={item.brand_name!='HOTPLE' ? styles.itemframe : styles.itemframeDisabled} onClick={()=>whenItemClicked(item)}>
                                <img className={styles.itemimageIcon} alt="" src={item.goods_img_s} onError={(e) => { e.currentTarget.src = "/images/info.svg"; }}/>
                                <div className={styles.itemdetail}>
                                    <div className={styles.iteminfo}>
                                            <div className={styles.itembrand}>
                                                {item.brand_icon_img && <img className={styles.itemimageIcon2} alt="" src={item.brand_icon_img} />}
                                                {item.goods_type_dtl_nm=='핫플' && <img className={styles.itemimageIcon3} alt="" src='images/fire.svg' />}
                                                [{item.brand_name}]
                                                {item.goods_type_dtl_nm=='핫플' && <div className={styles.hotBadge}>EVENT</div>}
                                            </div>
                                            <div className={styles.itemname}>{item.goods_name}</div>
                                    </div>
                                    <div className={styles.itemprice}>
                                            <div className={styles.discountprice}>{(parseInt(item.sale_price * (100-getDiscountRate(item))/100/10)*10).toLocaleString()}HP</div>
                                            {getDiscountRate(item)>0 && <div className={styles.price}>{item.sale_price.toLocaleString()}HP</div>}
                                            {getDiscountRate(item)>0 && <div className={styles.discountrate}>↓{getDiscountRate(item)}%</div>}
                                    </div>
                                </div>
                                <img className={styles.rightbuttoninnerframeIcon} alt="" src="images/chevron_bottom.svg" />

                        </div>
                    ))}
                    <div style={{height:"58px"}}/>
                    </div>
            </div>
            {isMobile &&
                <img className={styles.topButton} onClick={whenTopButtonClicked}  alt="" src="images/chevron_bottom.svg" />
            }
        </div>
    );
};

export default ShopContents;
